<template>
  <View direction="row" gap="md" align="start" class="layout">
    <View direction="column" gap="md" class="main-column">
      <slot />
    </View>

    <View direction="column" gap="md" class="side-rail">
      <slot name="rail" />
    </View>
  </View>
</template>

<script setup lang="ts">
import { View } from '@tallo/design-system';
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.main-column {
  flex: 1;
  min-width: 0;
}

.side-rail {
  width: 20rem;
  flex: 0 0 auto;
}

@include screen-max-md {
  .layout {
    flex-direction: column;
  }

  // Stacked, the row's align-start shrinks each column to its content, so both must claim the width.
  .side-rail,
  .main-column {
    width: 100%;
  }
}
</style>
